import idWithZeros from '@/helpers/idWithZeros'
import store from '@/store'

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    let id = store.state.invoice.id
    let automaticId = idWithZeros(id)
    return value !== automaticId
  }
}
